import { render, staticRenderFns } from "./transfer-detail.vue?vue&type=template&id=44a656b2&scoped=true&"
import script from "./transfer-detail.vue?vue&type=script&lang=js&"
export * from "./transfer-detail.vue?vue&type=script&lang=js&"
import style0 from "./transfer-detail.vue?vue&type=style&index=0&id=44a656b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a656b2",
  null
  
)

export default component.exports